const PATH = "/api/v1/profile";

const ENDPOINTS = {
  ZO_PROFILE_ME: "/me/",
  PROFILE_CUSTOM_NICKNAME_AVAILABLE: "/custom-nickname/available/",
};

export type ZoProfileEndpoints = keyof typeof ENDPOINTS;
export const ZoProfileCollection = { PATH, ENDPOINTS };
